<div
	class="grid h-full grid-cols-1"
	style="grid-template-rows: min-content min-content 1fr"
>
	<h4 class="mb-10">Sync mortgage instructions with your matter</h4>

	<app-step-progress-nav
		[steps]="steps"
		[current]="selectedIndex"
		(stepClicked)="goTo($event)"
		[clickable]="true"
	></app-step-progress-nav>

	<div class="overflow-auto">
		<app-llc-borrowers-sync
			*ngIf="selectedStep === allSteps.BORROWERS"
			(next)="next()"
			[transaction]="transaction"
			class="h-full"
		></app-llc-borrowers-sync>
		<app-llc-purchase-price-sync
			*ngIf="selectedStep === allSteps.SALE_PRICE"
			(next)="next()"
			[transaction]="transaction"
			class="h-full"
		></app-llc-purchase-price-sync>
		<app-llc-sync-data
			*ngIf="selectedStep === allSteps.SYNC_DATA"
			(next)="goToMortgage()"
			[transaction]="transaction"
			class="h-full"
		></app-llc-sync-data>
	</div>
</div>
